import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
const steps = ["Download the volumes.", "Explore the decision trees.", "Use the case organizer.", "Work through the reasoning challenges.", "Review the clinical matrices."];
export function Guarantee() {
  return <section className="px-4 py-16 md:py-24" aria-labelledby="guarantee-title" data-id="element-147" data-mp="29eq7v7gkcjjb">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-go/30 bg-white p-6 text-center sm:p-10" data-id="element-148" data-mp="2edt1zwv095ci">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-go text-white" data-id="element-149" data-mp="2jb1na6bg9phz">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-150" data-mp="2ocijvpmwipsr" />
        </span>
        <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-go-deep" data-id="element-151" data-mp="2sd2f2nnwzjc9">7-Day Guarantee</p>
        <h2 id="guarantee-title" className="mt-2 text-balance font-serif text-[1.9rem] font-black leading-tight text-ink md:text-5xl" data-id="element-152" data-mp="ty7vfia7xxni">
          Try the Sensory Decision Map™ risk-free
        </h2>
        <ul className="mx-auto mt-6 max-w-sm space-y-2 text-left" data-id="element-153" data-mp="3smhw6hkwhlvy">
          {steps.map(s => <li key={s} className="flex items-center gap-3 text-[16px] text-ink" data-id="element-154" data-mp="3ntor1slisbjc">
              <span className="h-2 w-2 shrink-0 rounded-full bg-go" aria-hidden="true" data-id="element-155" data-mp="3iuu0g4hb9ioo" />
              {s}
            </li>)}
        </ul>
        <p className="mt-6 text-[16px] leading-relaxed text-muted" data-id="element-156" data-mp="3dyd9z3mn2s8f">
          If you decide within 7 days that the system isn't useful for your professional learning and organization, simply
          request a refund according to the applicable purchase terms.{" "}
          <strong className="text-ink" data-id="element-157" data-mp="5fpdpak8ok4a">No complicated process. No pressure.</strong>
        </p>
        <div className="mt-8" data-id="element-158" data-mp="gm6bjgse1t5">
          <CtaButton label="Try the system risk-free" data-id="element-159" data-mp="he490xuwbml" />
        </div>
      </div>
    </section>;
}